import { Component, OnInit } from "@angular/core";
import { switchMap } from 'rxjs/operators';
import { ParamMap, ActivatedRoute } from '@angular/router';
import { DResult } from 'src/app/models/common.models/dresult.model';
import { DPaging } from 'src/app/models/common.models/dpaging.model';
import { VideoGetListOutputDTO } from 'src/app/models/contents.models/Video.models/VideoGetListOutputDTO.model';
import { API_ServerAddress } from 'src/app/MyAppCommonConfig';
import { StaticPageGetByPageKeyOutputDTO } from 'src/app/models/contents.models/staticPage.models/staticPageGetByPageKeyOutputDTO.model';
import { SiteSEOHelperService } from 'src/app/services/siteseoHelper.service';
import { StaticPagesSiteService } from 'src/app/services/staticPagesSite.service';
import { VideosSiteService } from 'src/app/services/videosSite.service';
import { PagingInputDTO } from 'src/app/models/common.models/pagingInputDTO.model';

@Component({
  selector: "videos",
  templateUrl: "videos.component.html"
})
export class VideosComponent implements OnInit {
  ngOnInit(): void {
    this.GetCommonPage();

    this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) => {
          this.currentPage = Number(params.get("pageNumber"));
          return this.GoToPage(this.currentPage);
        })
      )
      .subscribe((data: DResult<DPaging<VideoGetListOutputDTO>>) => {
        if (data.isSuccess) {
          this.itemsPaging = data.result;
          this.FillPager(this.itemsPaging.totalCount);
        }
      });
  }

  APIServerAddress: string = API_ServerAddress;
  pageKey: string = "VideosIndex";
  commonPage: StaticPageGetByPageKeyOutputDTO = new StaticPageGetByPageKeyOutputDTO();
  itemsPaging: DPaging<VideoGetListOutputDTO> = new DPaging();
  pager: number[] = [];
  currentPage: number = 1;
  countPerPage: number = 12;

  constructor(
    private route: ActivatedRoute,
    private siteSEOHelperService: SiteSEOHelperService,
    private staticPagesSiteService: StaticPagesSiteService,
    private videosSiteService: VideosSiteService
  ) {}

  GetCommonPage() {
    this.staticPagesSiteService
      .GetByPageKey(this.pageKey)
      .subscribe((data: DResult<StaticPageGetByPageKeyOutputDTO>) => {
        if (data.isSuccess) {
          this.commonPage = data.result;

          this.siteSEOHelperService.SetPageMetaData(
            this.commonPage.metaTitle,
            this.commonPage.metaDescription,
            this.commonPage.metaKeywords
          );
        }
      });
  }

  GoToPage(pageNumber: number) {
    var inputDTO = new PagingInputDTO();
    inputDTO.pageNumber = pageNumber;
    inputDTO.pageCount = this.countPerPage;

    return this.videosSiteService.GetPaging(inputDTO);
  }

  FillPager(totalCount: number) {
    this.pager = [];

    var pcount = totalCount / this.countPerPage;
    if (totalCount % this.countPerPage > 0) {
      pcount++;
    }
    for (let i = 1; i <= pcount; i++) {
      this.pager.push(i);
    }
  }

  MakeShortDescription(input: string, maxChar: number) {
    if (input.length <= maxChar) {
      return input;
    } else {
      return input.substring(0, maxChar) + " . . . ";
    }
  }
}
